import { proxy, proxyIdentity } from 'core/classes/helpers/UrlHelper'

export const isNewCoreServiceAvailable = () => {
  // TODO: compatible
  // The MBE method from App Designer has role-based restrictions.
  // We only need to check whether a user exists in the application, which is why we used the MBE method for the new service and the old form for the legacy method.
  // In the future, we should check users via the new service instead.
  return proxy('/test') !== proxyIdentity('/test')
}
